<template>
    <v-list-item two-line>
        <v-list-item-content>
            <v-list-item-subtitle>{{ reply.field.title }}</v-list-item-subtitle>
            <v-list-item-title
                    v-if="isUrl"
                    style="white-space: normal !important;">
                <a :href="reply.field_text.value">{{ reply.field_text.value }}</a>
            </v-list-item-title>
            <v-list-item-title
                    v-else
                    style="white-space: normal !important;">
                {{ reply.field_text.value }}
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: "FieldTextReply",
        props: {
            reply: {type: Object, default: () => {}}
        },
        computed: {
            isUrl() {
                return this.reply.field.text.type === 'url'
            }
        }
    }
</script>

<style scoped>

</style>